// extracted by mini-css-extract-plugin
module.exports = {"tablecont":"pie_tablecont__19ZJN","piechrtcont":"pie_piechrtcont__16-B8","tableetr":"pie_tableetr__w-X-t","titletd":"pie_titletd__2yq4i","durationtd":"pie_durationtd__2EuCC"};